import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import Breadcrumbs from '../components/Breadcrumbs';
import { breadcrumbSchema, webPageSchema } from '../lib/seo';
import { Button } from '../components/ui/button';
import { testimonials } from '../data/content';

export default function TestimonialsPage() {
  const path = '/testimonials';
  const title = 'Client Testimonials | Founder Growth Collective';
  const description = 'Founder testimonials for Founder Growth Collective: sales function design, repeatable sales methodology and coaching that raised close rates and team confidence.';
  const bc = [{ name: 'Home', path: '/' }, { name: 'Testimonials', path }];
  const schemas = [
    webPageSchema({ path, name: title, description }),
    breadcrumbSchema(bc),
  ];

  return (
    <div className="bg-[#EBE4DE] text-[#2E2C28] min-h-screen">
      <SEO title={title} description={description} path={path} schemas={schemas} />
      <Navbar />
      <main className="pt-36 pb-24">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
          <Breadcrumbs items={bc} />

          <header className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-8">
            <div className="lg:col-span-4">
              <p className="sec-num text-sm tracking-[0.3em] uppercase">/ Testimonials</p>
            </div>
            <div className="lg:col-span-8">
              <h1 className="font-serif text-[40px] sm:text-[52px] lg:text-[64px] leading-[1.02] tracking-[-0.015em] text-[#2E2C28] font-light">
                What founders <span className="italic text-[#B5876C]">say</span>.
              </h1>
            </div>
          </header>

          <div className="mt-20 space-y-16 lg:space-y-24">
            {testimonials.map((t, i) => (
              <figure key={i} className="grid grid-cols-1 lg:grid-cols-12 gap-8 border-t border-[#d9d2ca] pt-12">
                <div className="lg:col-span-2 sec-num text-xl">{String(i + 1).padStart(2, '0')}</div>
                <blockquote className="lg:col-span-10">
                  <p className="font-serif italic text-2xl lg:text-3xl leading-[1.4] text-[#2E2C28] font-light">
                    “{t.quote}”
                  </p>
                  <figcaption className="mt-8 flex items-center gap-4">
                    <div className="w-12 h-px bg-[#B5876C]" />
                    <div>
                      <p className="text-sm tracking-[0.16em] uppercase text-[#2E2C28] font-medium">{t.author}</p>
                      {t.org && <p className="text-xs tracking-[0.2em] uppercase text-[#7a7369] mt-1">{t.org}</p>}
                    </div>
                  </figcaption>
                </blockquote>
              </figure>
            ))}
          </div>

          <div className="mt-24">
            <Button asChild className="bg-[#2E2C28] hover:bg-[#B5876C] text-[#EBE4DE] rounded-none h-14 px-8 text-[12px] tracking-[0.2em] uppercase">
              <Link to="/contact" className="inline-flex items-center gap-3">Book a Discovery Call <ArrowUpRight size={16} strokeWidth={1.5} /></Link>
            </Button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
